export default __webpack_public_path__ + "static/bg-1-f87dfcb93db9b01c30264290721ee37d.jpg";